import React from 'react'
import ReactLoading from 'react-loading'
import classnames from 'classnames'

import { Tooltip } from 'antd'

import './index.less'

const Button = ({
  tooltipPlacement = 'top',
  loading = false,
  zIndex = 98,
  showTooltip = false,
  tooltipText = '',
  type = 'primary',
  bold = false,
  onClick,
  disabled = false,
  className,
  ...props
}) => {
  function handleClick() {
    if (disabled || loading) return
    onClick && onClick()
  }
  // style
  let propClass = 'prop-class-'
  if (type == 'dashed') {
    propClass += 'dashed' // 线性
  } else {
    propClass += 'primary' // 默认
  }

  return (
    <div id="inft-button-area" className={classnames('cust-button', className)}>
      <Tooltip
        zIndex={zIndex}
        visible={showTooltip}
        color="#000"
        placement={tooltipPlacement}
        title={tooltipText}
        getPopupContainer={() => document.getElementById('inft-button-area')}
      >
        <div
          onClick={handleClick}
          {...props}
          className={classnames(
            'button-container',
            propClass,
            disabled ? (type == 'dashed' ? 'button-disabled-dashed' : 'button-disabled-primary') : ''
          )}
        >
          <div className={classnames('button-text', { 'button-text-bold': bold })}>
            {loading && (
              <ReactLoading className="cust-button-loading" type="spokes" color="#fff" height={14} width={14} />
            )}

            {props.children}
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

export default Button
